import React from 'react';

import {
  Explainer,
  Flex,
  OneHalfLayout,
  PageWrapper,
  Panel,
  Placeholder
} from '@ubisend/pulse-components';
import { useQuery, useMutation, useQueryClient } from '@ubisend/pulse-hooks';
import { PolicyAccept, BackButton } from '@ubisend/pulse-channels';

import { acceptPolicy as acceptPolicyApi } from '../api/index';
import SmsDataForm from '../Components/SmsDataForm';

const SmsLink = () => {
  const query = useQuery({
    queryKey: [
      'sms/settings'
    ]
  });

  const queryClient = useQueryClient();

  const { mutate: acceptPolicy } = useMutation({
    mutationFn: acceptPolicyApi,
    onSuccess: () => {
      queryClient.invalidateQueries('sms/settings');
    }
  });

  const PolicyCheck = () => {
    if (!query.data.data.has_given_data_consent) {
      return (
        <PolicyAccept
          handlePolicyAccept={acceptPolicy}
          policyUrl="https://sopranodesign.com/privacy/"
        />
      );
    }

    return (
      <Panel divider header="Link your SMS">
        <Flex col>
          <Explainer mb>
            Please fill out the fields below in line with Soprano Design SMS
            Provider API.{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="/docs">
              Learn more
            </a>
            .
          </Explainer>
          <SmsDataForm
            number={query.data.data.phone_number}
            token={query.data.data.api_key}
            prevBaseUri={query.data.data.base_uri}
            noSecret={query.data.data.has_not_api_secret}
          />
        </Flex>
      </Panel>
    );
  };

  return (
    <PageWrapper
      center
      half
      header="SMS"
      prevAction={<BackButton to="/channels" />}>
      <Flex col center>
        <OneHalfLayout>
          {query.isLoading && <Placeholder items={1} subitems={2} />}
          {query.isSuccess && <PolicyCheck />}
        </OneHalfLayout>
      </Flex>
    </PageWrapper>
  );
};

export default SmsLink;
